<template>
  <div class="space-between-y">

    <el-dialog
        title="园长认证信息"
        :visible.sync="info.dialog"
        width="400px"
    >
      <div class="space-between-y">
        <cus-certification :user-id="info.userId" v-if="info.dialog"></cus-certification>

        <div class="container-center">
          <el-button type="danger" @click="delCertification">删除认证信息</el-button>
        </div>
      </div>


    </el-dialog>

    <el-dialog
        title="园长审核"
        :visible.sync="examineDialog"
    >
      <customer-examine @updated="getData" v-if="examineDialog"></customer-examine>
    </el-dialog>

    <div>
      <el-button type="primary" @click="examineDialog = true">园长审核</el-button>
    </div>

    <el-table
        :data="users"
        border stripe
    >
      <el-table-column prop="id" label="用户编号"></el-table-column>
      <el-table-column prop="nickname" label="用户名"></el-table-column>
      <el-table-column prop="phone" label="手机号"></el-table-column>
      <el-table-column prop="examine" label="认证状态">
        <template v-slot:default="scope">
          <el-tag size="mini" v-if="scope.row.examine === 'APPROVED'" type="success">认证通过</el-tag>
          <el-tag size="mini" v-else-if="scope.row.examine === 'PENDING'" type="warn">待审核</el-tag>
          <el-tag size="mini" v-else-if="scope.row.examine === 'REJECTED'" type="danger">认证失败</el-tag>
          <el-tag size="mini" v-else type="info">未提交</el-tag>
        </template>
      </el-table-column>

      <el-table-column header-align="center" align="center" width="70" label="操作">
        <template v-slot:default="scope">
          <el-button size="mini" @click="detail(scope.row.id)" type="text">查看</el-button>
        </template>
      </el-table-column>

    </el-table>
    <pagination v-model="page" @updated="getData()"></pagination>

  </div>
</template>

<script>
import {user} from "@/api/user";
import CustomerExamine from "@/components/user/CustomerExamine.vue";
import CusCertification from "@/components/user/CusCertification.vue";
import {msg} from "@/assets/js/my-vue-element-ui-js";
import Pagination from "@/components/base/layout/Pagination.vue";

export default {
  name: 'CustomerList',
  components: {Pagination, CusCertification, CustomerExamine},

  data() {
    return {
      page: {
        size: 10,
        current: 1,
        total: 0,
      },
      users: [],

      examineDialog: false,

      info: {
        dialog: false,
        userId: "",
      },


    };
  },

  methods: {
    getData() {
      user.customerList(this.page.size, this.page.current).then(res => {
        let page = res.data;
        this.users = page.list;
        this.page.total = page.total;
      });
    },

    detail(id) {
      this.info.dialog = true;
      this.info.userId = id;
    },

    delCertification() {
      this.$confirm("确定删除该园长认证信息？删除后将无法恢复！且园长将看不到商品价格，请确认").then(() => {
        user.delCertification(this.info.userId).then(res => {
          msg(res, this);
          if (res.code === 200) {
            this.getData();
            this.info.userId = "";
            this.info.dialog = false;
          }
        })
      })

    },

  },

  created() {
    this.getData();
  },


};
</script>

<style scoped>
</style>
